<mat-card>{{'serviceAmountFees' | translate}}</mat-card>

<div align="end" class="row" style="padding: 10px 0 0 10px ;">

    <button mat-raised-button color="primary" (click)="submit()" [disabled]="ServiceAmountsFeesForm.invalid">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
</div>

<form [formGroup]="ServiceAmountsFeesForm" #formDir="ngForm" style="padding-right: 10px;">

    <div formArrayName="serviceAmountsFees">
        <div *ngFor="let item of getServiceAmountsFeesControls();let i = index" [formGroupName]="i">
            <mat-grid-list cols="4" rowHeight="70px">

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'fromAmount' | translate}}</mat-label>
                        <input matInput type="number" formControlName="fromAmount">
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'toAmount' | translate}}</mat-label>
                        <input matInput type="number" formControlName="toAmount">
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'fee' | translate}}</mat-label>
                        <input matInput type="number" formControlName="fees">
                    </mat-form-field>
                </mat-grid-tile>


                <mat-grid-tile>

                    <button type="button" *ngIf="i == getServiceAmountsFeesControls().length -1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon"
                        (click)="addServiceAmountsFeesRow()">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button type="button" *ngIf="getServiceAmountsFeesControls().length > 1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon" (click)="deleteRow(i)">
                        <mat-icon>delete</mat-icon>
                    </button>

                </mat-grid-tile>

            </mat-grid-list>



        </div>

    </div>
</form>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>